<template>
    <div class="base-mit-volume-analytics">
        <v-card flat>
            <v-card-title class="text-h5"><v-icon class="pr-1">{{icon}}</v-icon>{{title}}</v-card-title>
            <v-card-subtitle v-if="subTitle.length > 0">{{subTitle}}</v-card-subtitle>
            <v-row class="pa-4" justify="space-between">
                <v-col cols="8">
                    <v-card flat>
                        <canvas id="lineTop10volumes"></canvas>
                    </v-card>
                </v-col>
                <!-- <v-divider vertical></v-divider> -->
                <v-col cols="4">
                    <v-card flat>
                        <canvas id="pieTop10"></canvas>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
// import Chart from 'chart.js/auto';
import Chart from 'chart.js/auto';

export default {
  name: 'MitVolumesAnalytics',
  components: {
  },
  props: {
      title:{
          default:'Volume Analytics',
          type:String
      },
      subTitle:{
          default:'',
          type:String
      },
      icon:{
          default:'',
          type:String
      },
    dataTopActivity: {
      default: {
          data:[],
          dataLabels:[],
          title:'',
          labelX:'',
          labelY:''
      },
      type: Object
    },
    dataTopUsers: {
      default: {
          data:[],
          dataLabels:[],
          title:'',
          labelX:'',
          labelY:''
      },
      type: Object
    }
  },
  data: function() {
    return {
    }
  },
  created() {
  },
  mounted() {
      const ctxPie = document.getElementById('pieTop10');
      const pie = new Chart(ctxPie, {
            type: 'pie',
            options: {
                responsive: true,
                plugins: {
                  legend: {
                    position: 'bottom',
                  },
                  title: {
                    display: true,
                    text: this.dataTopUsers.title
                  }
                }
            },
            data:{
              labels: this.dataTopUsers.dataLabels,
              datasets: [{
                label: '(GB)',
                data: this.dataTopUsers.data,
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)'
                ],
                hoverOffset: 4,
                borderWidth: 1,
          }]
        }
      });
      const ctxLine = document.getElementById('lineTop10volumes');
      const line = new Chart(ctxLine, {
            type: 'bar',
            data: {
                labels: this.dataTopActivity.dataLabels,
                datasets: [{
                    label: '(GB)',
                    data: this.dataTopActivity.data,
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)'
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)'
                    ],
                    borderWidth: 1
                }]
            },
            options: {
                responsive: true,
                plugins: {
                  legend: {
                    position: 'none',
                  },
                  title: {
                    display: true,
                    text: this.dataTopActivity.title
                  }
                },
                scales: {
                    x: {
                        ticks: {
                            // Include a dollar sign in the ticks
                            callback: (index) => {
                                let label = this.dataTopActivity.dataLabels[index];
                                if(label.length > 20){
                                    let arr = label.split('/');
                                    return '.../'+arr[arr.length-1];
                                }
                                return label;
                            }
                        }
                    },
                    y: {
                        beginAtZero: false,
                        title: {
                            display: true,
                            text: this.dataTopActivity.labelY
                        },
                        //type: 'logarithmic'
                    }
                }
            }
        });
  },
  methods : {
    nodeClicked(node){
        this.$emit('click:node',node[0]);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
